import { LEADS_COUNT_GET } from "../../constant/ActionType";

export default function ActivityWiseLeadsCounts(
    state = {
        leadscountsdata: [],
        statusCode: null,
    },
    action
) {
    switch (action.type) {
        case LEADS_COUNT_GET:
            return {
                ...state,
                leadscountsdata: action.data,
                statusCode: action.status,
            };

        default:
    }

    return state;
}
